import * as React from 'react'
import { View } from 'react-native'
import type { StyleProp, ViewStyle } from 'react-native'
import * as Colors from '@themes/Colors'

export function CustomSpacer({
  shrink = 0,
  grow = 0,
  height = 200,
  width = '100%',
  backgroundColor = Colors.transparent,
  style = {},
}: {
  shrink?: number
  grow?: number
  height?: number
  width?: number | string
  backgroundColor?: string
  style?: StyleProp<ViewStyle>
}) {
  return (
    <View
      style={[
        { flexShrink: shrink, flexGrow: grow, height, width, backgroundColor },
        style,
      ]}
    />
  )
}

export default CustomSpacer
